module.exports = __webpack_public_path__ + "static/img/liwu@2x.37d27fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/liwu@2x.png
// module id = bEG0
// module chunks = 3